
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"m11.376 27.616-9.852 2.312 2.311-9.852 17.657-17.66a3.05 3.05 0 0 1 4.31 0l3.234 3.233a3.05 3.05 0 0 1 0 4.31l-17.66 17.657zm16.586-16.58L20.415 3.49M11.76 27.23l-7.542-7.542","vector-effect":"non-scaling-stroke"}})])
          )
        }
      }
    